<template>
  <v-form v-model="valid">
    <v-container class="pa-0" fluid>
      <v-row dense>
        <v-col cols="12">
          <v-select
            v-model="localFormData.ACCOUNT"
            :rules="[rules.required]"
            :items="items"
            :label="$t('FORMS.BANK_ACCOUNT.CHOOSE_ACCOUNT') + ' *'"
            hide-details
            solo
            :append-icon="errors.account ? 'mdi-alert-circle-outline' : 'mdi-chevron-down'"
            @update:error="errors = { ...errors, account: $event }"
          ></v-select>
        </v-col>
      </v-row>

      <v-row v-if="localFormData.ACCOUNT == $t('FORMS.BANK_ACCOUNT.BANK')" dense>
        <v-col cols="12">
          <v-text-field
            v-model="localFormData.NAME_OF_BANK"
            :rules="[rules.required]"
            :label="$t('FORMS.BANK_ACCOUNT.NAME_OF_BANK') + ' *'"
            hide-details
            solo
            counter="30"
            :append-icon="errors.name_of_bank ? 'mdi-alert-circle-outline' : null"
            @update:error="errors = { ...errors, name_of_bank: $event }"
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="localFormData.IBAN"
            :rules="[rules.required]"
            :label="$t('FORMS.BANK_ACCOUNT.IBAN') + ' *'"
            hide-details
            solo
            counter="34"
            :append-icon="errors.iban ? 'mdi-alert-circle-outline' : null"
            @update:error="errors = { ...errors, iban: $event }"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="localFormData.ACCOUNT == $t('FORMS.BANK_ACCOUNT.SWISS_POST')" dense>
        <v-col cols="12">
          <v-text-field
            v-model="localFormData.POSTCHECK_ACCOUNT"
            :rules="[rules.required]"
            :label="$t('FORMS.BANK_ACCOUNT.POSTCHECK_ACCOUNT') + ' *'"
            hide-details
            solo
            counter="30"
            :append-icon="errors.postcheck_account ? 'mdi-alert-circle-outline' : null"
            @update:error="errors = { ...errors, postcheck_account: $event }"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense text-center>
        <v-col cols="12">
          <slot name="button" :valid="valid" />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <slot name="description" />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Rules from "@/app/modules/_global/classes/Rules";

export default {
  name: "BankAccountForm",

  model: {
    prop: "formData"
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  data: vm => ({
    localFormData: null,

    status: null,
    items: [vm.$t("FORMS.BANK_ACCOUNT.BANK"), vm.$t("FORMS.BANK_ACCOUNT.SWISS_POST")],

    valid: true,
    errors: {},

    rules: {
      required: Rules.required
    }
  }),

  watch: {
    localFormData: {
      deep: true,
      handler: "setFormData"
    }
  },

  created() {
    this.localFormData = Object.assign({}, this.formData);
  },

  methods: {
    setFormData() {
      this.$emit("input", this.localFormData);
    }
  }
};
</script>
